import type { Transition } from 'framer-motion';

// ----------------------------------------------------------------------

/**
 * 이 가족의 모든 `var*` 함수가 받는 옵션 꼴.
 * `distance`·`deg` 처럼 갈래마다만 뜻이 있는 칸은 각 파일에서 교차로 얹는다.
 */
export type VariantsTransitionOptions = {
  transition?: Transition;
  transitionIn?: Transition;
  transitionOut?: Transition;
};

export const transitionEnter = (props?: Transition): Transition => ({
  duration: 0.64,
  ease: [0.43, 0.13, 0.23, 0.96],
  ...props,
});

export const transitionExit = (props?: Transition): Transition => ({
  duration: 0.48,
  ease: [0.43, 0.13, 0.23, 0.96],
  ...props,
});
